import { Component, HostListener, inject, OnDestroy, OnInit } from '@angular/core';
import { NotificationsService } from '../../../core/services/notifications/notifications.service';
import { TokenService } from 'src/app/core/services/tokenservice/token.service';
import { LogoutService } from 'src/app/core/auth/logout.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  itemCount: number = 0;
  isOpen = false;
  isArrowDown: boolean = true;
  hasPrivilege: boolean = false;
  private tokenSub!: Subscription

  constructor(
    private notificationService: NotificationsService,
    private tokenService: TokenService,
    private logoutService: LogoutService,
  ) { }

  ngOnInit(): void {
    this.itemCount = this.notificationService.itemCount;

    this.tokenSub = this.tokenService.token$.subscribe(() => {
      this.checkPrivileges();
    });

    this.checkPrivileges();
  }

  ngOnDestroy() {
    this.tokenSub?.unsubscribe();
  }

  get hasToken(): boolean {
    return !!this.tokenService.getToken();
  }

  toggleDropdown() {
    this.isArrowDown = !this.isArrowDown
    this.isOpen = !this.isOpen;
  }

  onLogout(): void {
    this.logoutService.logout('logout');
  }

  @HostListener('document:click', ['$event'])
  closeDropDown(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.header-dropdown')) {
      this.isOpen = false;
    }
  }

  getShortName(): string {
    const fullName = this.tokenService.getUserNameFromToken();
    const nameParts = fullName.split(' ');
    if (nameParts.length > 1) {
      return `${nameParts[0]} ${nameParts[nameParts.length - 1]}`;
    }
    return fullName;
  }

  private checkPrivileges(): void {
    const roles = this.tokenService.getRolesFromToken();
    this.hasPrivilege = roles.includes('PORTALCAU_PRIVILEGIADO_BVMF');
  }
}
